import { Component, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { escapeHtml } from '@angular/platform-browser/src/browser/transfer_state';
import { UtilsService } from '../../services/utils.service';
import { NotificationService } from '../../services/notification.service';
import { LanguagePipe } from '../../services/language.pipe';
import { KindsModalComponent } from '../kindsmodal/kindsmodal.component';
import { HistoryComponent } from '../history/history.component';
import { MergeMapToSubscriber } from 'rxjs/operators/mergeMapTo';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css']
})
export class InformationComponent {

  @ViewChild(KindsModalComponent) kindsModal: KindsModalComponent;
  @ViewChild(HistoryComponent) history: HistoryComponent;

  public turn: object;
  public counter: string = "00:00";
  public interval: any;
  public allCallsInterval: any;
  public enableTurnInformation: boolean = true;
  public ccode: string = "";
  public saveCcode: number = 0;
  public maxTimeExceded: number = 0;

  public clientName: string = "";
  public clientDNI: string = "";
  public clientObservations: string = "";

  public clientDataAlert: boolean = false;

  public showObservation: boolean = false;

  public viewers: Array<object> = [];

  public allCalls: Array<object> = [];

  private destroy$ = new Subject();

  constructor(public _data: DataService,
    private _blogic: BusinesLogicService,
    private _utils: UtilsService,
    private _notify: NotificationService,
    private _lang: LanguagePipe,
    public data: DataService,
    private _modal: ModalHelper) { }

  ngOnInit() {
    this._updateTurn(this._data.turn);
    this._data.turnUpdate
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: object) => {
          this._updateTurn(response);
        }
      );
    this.getViewers();
    this.getAllCalls();

    if (this._data.configuration['showViewerInfo']) {
      this.getAllCalls();
      setInterval(() => {
        this.getAllCalls();
      }, 10000);
    }


  }

  ngOnDestroy() {
    clearInterval(this.interval);
    clearInterval(this.allCallsInterval);

    this.destroy$.next();
    this.destroy$.complete();
  }

  /* When the turn information change */
  private _updateTurn(turn: object): void {
    this.showObservation = true;
    setTimeout(() => {
      this.showObservation = false;
    }, 8000);
    clearInterval(this.interval);
    if (!this._data.turnIsActive()) {
      this.turn = null;
      this.ccode = "";
    } else {
      this.turn = turn;
      this.maxTimeExceded = 0;
      if (this._data.configuration["showCcodeInputMode"] == 1) {
        this.ccode = this.turn['ccode'];
      } else {
        this.ccode = this.turn['clientid'];
      }
      this.turn["twaiting"] = this._utils.getWaitTime(turn["initdatetime"], turn["deskdatetime"], false);
      this.animateTurn();
      this._initCounter();
    }
  }

  /* Init the attention time counter */
  private _initCounter(): void {
    clearInterval(this.interval);
    var min: any = 0;
    var sec: any = 0;
    var send: number = 0;

    this.interval = setInterval(() => {
      sec++;
      if (sec == 60) {
        sec = 0;
        min++;
      }
      sec = "00" + String(sec);
      sec = sec.slice(sec.length - 2, sec.legth);
      min = "00" + String(min);
      min = min.slice(min.length - 2, min.legth);

      if (parseInt(min) + 1 == this.turn["maxtime"]) {
        this.maxTimeExceded = 1;
      }

      if (parseInt(min) >= this.turn["maxtime"] && this.turn["maxtime"] != 0) {
        this.maxTimeExceded = 2;

        if (this._notify.hasPermission() && send == 0) {
          this._notify.notify(this._lang.transform("notifyTitleTimeExceded"), this._lang.transform("notifyBodyTimeExceded"));
          send++;
        }

      }
      this.counter = min + ":" + sec;
    }, 1000);
  }

  /* Refresh the div for animate it */
  public animateTurn(): void {
    this.enableTurnInformation = false;
    setTimeout(() => {
      this.enableTurnInformation = true;
    }, 0);
  }

  /* Open the atypes modal */
  public openAtypesModal(): void {
    this.kindsModal.openKindModal("atypesModal");
  }

  //  Si saveCcode = 1 quiere decir que está cargando la peticición, 0 muestra el botón de guardar y 2 muestra el check.
  public changeCcode() {
    this.saveCcode = 1;
    let params = {};

    if (this._data.configuration["showCcodeInputMode"] == 1) {
      params = {
        desk_id: this._data.session["desk"],
        turn_id: this._data.turn["id"],
        queue_id: this._data.turn["queue_id"],
        prekind: this._data.turn["prekind"],
        task: this._data.turn["task"],
        ccode: this.ccode,
        planhour: this._data.turn["planhour"],
        plandate: this._data.turn["plandate"]
      };
    } else {
      params = {
        desk_id: this._data.session["desk"],
        turn_id: this._data.turn["id"],
        queue_id: this._data.turn["queue_id"],
        prekind: this._data.turn["prekind"],
        task: this._data.turn["task"],
        clientid: this.ccode,
        planhour: this._data.turn["planhour"],
        plandate: this._data.turn["plandate"]
      };
    }

    this._blogic.setTicketInfo(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {

          if (this._data.configuration["showCcodeInputMode"] == 2) {
            this.turn["clientid"] = this.ccode;
          }

          this.saveCcode = 2;
          setTimeout(() => {
            this.saveCcode = 0;
          }, 1500);
        }
      );

  }

  openClientData() {
    this.clientName = this.turn["clientname"];
    this.clientDNI = this.turn["clientid"];
    this.clientObservations = this.turn["rdcomment"];
    this._modal.show("clientDataModal");
  }

  saveClientData() {

    let params = {
      desk_id: this._data.session["desk"],
      turn_id: this._data.turn["id"],
      queue_id: this._data.turn["queue_id"],
      prekind: this._data.turn["prekind"],
      task: this._data.turn["task"],
      clientid: this.clientDNI,
      clientname: this.clientName,
      rdcomment: this.clientObservations,
      planhour: this._data.turn["planhour"],
      plandate: this._data.turn["plandate"]
    };

    this._blogic.setTicketInfo(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.clientDataAlert = true;
          this.turn["clientid"] = this.clientDNI;
          this.turn["clientname"] = this.clientName;
          this.turn["rdcomment"] = this.clientObservations;

          setTimeout(() => {
            this.clientDataAlert = false;
            this._modal.hide("clientDataModal");
          }, 2000);
        }
      );
  }

  getViewers() {
    let params = {
      desk_id: this._data.session["desk"]
    };

    this._blogic.getViewers(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.viewers = response;
        }
      );
  }

  getTurnStatus(viewer, turn) {
    let i = 0;
    let status = "loading";
    for (let e of this._data.turnStatusInViewer) {
      if ((viewer == e["viewer"]) && (turn.id == e["turn_id"])) {
        if (e["result"] === true) {
          status = "success";
        }

        if (e["result"] === false) {
          status = "error";
        }
        break;
      }
      i++;
    }
    return status;

  }

  getAllCalls() {
    let params = {
      desk_id: this._data.session["desk"]
    };
    this._blogic.getAllCalls(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          this.allCalls = response;
        },
        (err) => { });
  }

}
